export default class Isi {
    constructor() {
        this.windowHeight = window.innerHeight;
        this.homeBase = document.getElementById("isi");
        this.stickyIsi = document.querySelector(".isi-container");
        this.isiButton = document.querySelector(".isi-button");
        this.init();

        window.addEventListener('hashchange', () => {
            if (window.location.href.includes('screenshot')) {
                window.location.reload();
            }
        });
    }
    init() {
        if (!this.homeBase) return;

        if (window.location.href.includes('screenshot')) {
            this.enableScreenshotMode();
            return;
        }

        if (document.body.clientHeight < 2200) {
            this.stickyIsi.classList.remove("isi-container--fixed");
            this.isiButton.remove();
        } else {
            window.addEventListener("scroll", () => {
                if (window.scrollY + this.windowHeight - 200 > this.homeBase.offsetTop) {
                    this.stickyIsi.classList.remove("isi-container--fixed");
                } else {
                    this.stickyIsi.classList.add("isi-container--fixed");
                }
            });
        }
    }
    enableScreenshotMode() {
        this.stickyIsi.classList.remove("isi-container--fixed");
        if (this.isiButton) {
            this.isiButton.style.display = 'none';
            this.isiButton.classList.remove('isi-button--active');
        }
    }
}